import createSvgIcon from '../createSvgIcons'
// <path
//   d="M16 8L8 16M8 8L16 16L8 8Z"
//   stroke="currentColor"
//   strokeWidth="2"
//   strokeLinecap="round"
//   strokeLinejoin="round"
// />
/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_4125_7081)">
      <path
        d="M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4125_7081">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>,
  'Close'
)
